import styled from 'styled-components';

export const Div = styled.div`
  .star {
    height: 30%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
